
document.addEventListener('DOMContentLoaded',()=>{
 const header=document.querySelector('.site-header');
 const menu=document.querySelector('.mobile-panel');
 const open=document.querySelector('[data-menu-open]');
 const close=document.querySelector('[data-menu-close]');
 const toggle=()=>menu&&menu.classList.toggle('open');
 open&&open.addEventListener('click',toggle); close&&close.addEventListener('click',toggle);
 document.querySelectorAll('.mobile-panel a').forEach(a=>a.addEventListener('click',()=>menu.classList.remove('open')));
 window.addEventListener('scroll',()=>{if(header)header.classList.toggle('scrolled',window.scrollY>35)},{passive:true});
 document.querySelectorAll('[data-tilt]').forEach(card=>{
   card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`perspective(800px) rotateY(${x*10}deg) rotateX(${-y*10}deg)`});
   card.addEventListener('pointerleave',()=>card.style.transform='');
 });
 document.querySelectorAll('[data-qty]').forEach(box=>{
   const input=box.querySelector('input'),minus=box.querySelector('[data-minus]'),plus=box.querySelector('[data-plus]');
   minus?.addEventListener('click',()=>{input.value=Math.max(0,Number(input.value)-1); input.dispatchEvent(new Event('change',{bubbles:true}))});
   plus?.addEventListener('click',()=>{input.value=Number(input.value)+1; input.dispatchEvent(new Event('change',{bubbles:true}))});
 });
});

document.addEventListener('DOMContentLoaded',()=>{
  // Product variant picker
  const picker=document.querySelector('[data-variant-picker]');
  const variantJSON=document.getElementById('ProductVariantsJson');
  if(picker && variantJSON){
    let variants=[];
    try{variants=JSON.parse(variantJSON.textContent)}catch(e){}
    const groups=[...picker.querySelectorAll('[data-option-group]')];
    const buttons=[...picker.querySelectorAll('[data-option-value]')];
    const idInput=picker.querySelector('[data-variant-id]');
    const priceEl=document.querySelector('[data-product-price]');
    const addButton=document.querySelector('[data-add-button]');
    const status=document.querySelector('[data-variant-status]');

    const selected=()=>{
      return groups.map(g=>{
        const active=g.querySelector('.option-pill.is-selected');
        return active ? active.dataset.optionValue : null;
      });
    };
    const findVariant=()=>{
      const values=selected();
      return variants.find(v=>v.options.every((value,i)=>value===values[i]));
    };
    const updateAvailability=()=>{
      const values=selected();
      buttons.forEach(btn=>{
        const index=Number(btn.dataset.optionIndex);
        const value=btn.dataset.optionValue;
        const possible=variants.some(v=>{
          if(!v.available || v.options[index]!==value) return false;
          return v.options.every((opt,i)=>i===index || !values[i] || opt===values[i]);
        });
        btn.classList.toggle('is-disabled',!possible);
        btn.disabled=!possible;
      });
    };
    const update=()=>{
      const v=findVariant();
      if(v){
        idInput.value=v.id;
        if(priceEl && v.price!=null){
          priceEl.textContent='£'+(v.price/100).toFixed(2);
        }
        if(addButton){
          addButton.disabled=!v.available;
          addButton.textContent=v.available?'ADD TO BAG →':'SOLD OUT';
        }
        if(status) status.textContent=v.available?'READY TO ADD TO BAG':'THIS OPTION IS SOLD OUT';
      }else{
        if(addButton) addButton.disabled=true;
        if(status) status.textContent='SELECT AN OPTION';
      }
      updateAvailability();
    };
    buttons.forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled) return;
      const group=groups.find(g=>Number(g.dataset.optionIndex)===Number(btn.dataset.optionIndex));
      group?.querySelectorAll('.option-pill').forEach(b=>b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      update();
    }));
    update();
  }

  // Product quantity
  const pq=document.querySelector('[data-product-qty]');
  if(pq){
    const input=pq.querySelector('input'), minus=pq.querySelector('[data-product-minus]'), plus=pq.querySelector('[data-product-plus]');
    minus?.addEventListener('click',()=>input.value=Math.max(1,Number(input.value||1)-1));
    plus?.addEventListener('click',()=>input.value=Number(input.value||1)+1);
  }

  // Accordions
  document.querySelectorAll('[data-accordion]').forEach(btn=>btn.addEventListener('click',()=>btn.closest('.meta-item')?.classList.toggle('is-open')));

  // Size guide
  const modal=document.querySelector('[data-size-modal]');
  document.querySelectorAll('[data-size-guide]').forEach(btn=>btn.addEventListener('click',()=>{modal?.classList.add('is-open');modal?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}));
  modal?.querySelectorAll('[data-size-close]').forEach(el=>el.addEventListener('click',()=>{modal.classList.remove('is-open');modal.setAttribute('aria-hidden','true');document.body.style.overflow=''}));

  // Cart quantity controls submit the cart form
  document.querySelectorAll('[data-qty]').forEach(box=>{
    const input=box.querySelector('input'),minus=box.querySelector('[data-minus]'),plus=box.querySelector('[data-plus]');
    const form=box.closest('form');
    const refresh=()=>{input.dispatchEvent(new Event('change',{bubbles:true})); setTimeout(()=>form?.requestSubmit(),120)};
    minus?.addEventListener('click',()=>{input.value=Math.max(0,Number(input.value||0)-1);refresh()});
    plus?.addEventListener('click',()=>{input.value=Number(input.value||0)+1;refresh()});
  });
});
